// Those page which do not have pageName, it will dynamic.

const screens = {
  landing: {
    pageType: 'landing screen',
    pageName: 'landing screen'
  },
  home: {
    pageType: 'home screen',
    pageName: 'home screen'
  },
  search: {
    zeroSearchPageName: 'zero results screen',
    pageName: 'search plp screen',
    pageType: 'search screen'
  },
  searchPageBanner: {
    pageName: 'search screen',
    pageType: 'search screen'
  },
  plp: {
    pageType: 'plp screen'
  },
  pdp: {
    pageType: 'pdp screen',
    pageName: 'pdp screen'
  },
  cart: {
    pageType: 'bag screen',
    pageName: 'bag screen'
  },
  wishlist: {
    pageType: 'closet screen',
    pageName: 'closet screen'
  },
  shipping: {
    pageType: 'shipping screen',
    pageName: 'shipping screen'
  },
  addressSelection: {
    pageType: 'address management screen'
  },
  manageAddress: {
    pageType: 'address management screen'
  },
  paymentFailed: {
    pageType: 'payment screen',
    pageName: 'payment failed screen'
  },
  paymentRetry: {
    pageType: 'payment screen',
    pageName: 'payment retry screen'
  },
  orderConfirmation: {
    pageType: 'thank you screen',
    pageName: 'order confirmation screen'
  },
  login_signup: {
    pageType: 'user account screen',
    pageName: 'Login Social screen'
  },
  login_screen: {
    pageType: 'user account screen',
    pageName: 'login signup screen'
  },
  login_password: {
    pageType: 'user account screen',
    pageName: 'login password screen'
  },
  login_otp: {
    pageType: 'user account screen',
    pageName: 'login - otp screen'
  },
  signup: {
    pageType: 'user account screen',
    pageName: 'signup screen'
  },
  signup_otp: {
    pageType: 'user account screen',
    pageName: 'signup - otp screen'
  },
  social_mobilenumber: {
    pageType: 'user account screen'
  },
  social_otp: {
    pageType: 'user account screen'
  },
  otp_authentication: {
    pageType: 'user account screen',
    pageName: 'otp verify screens'
  },
  myAccountMain: {
    pageType: 'my account screen',
    pageName: 'my account screen'
  },
  orderList: {
    pageType: 'order management screen'
  },
  orderDetails: {
    pageType: 'order management screen',
    pageName: 'consolidated order details screen'
  },
  returnExchangeAddressSelection: {
    pageType: 'order management screen',
    pageName: 'return exchange address selection screen'
  },
  returnExchangeProductSelection: {
    pageType: 'order management screen',
    pageName: 'return exchange product selection screen'
  },
  returnExchangeSelection: {
    pageType: 'order_management_screen',
    pageName: 'return exchange mode selection screen'
  },
  returnExchangeReviewScreen: {
    pageType: 'order_management_screen',
    pageName: 'exchange size & reason review screen'
  },
  returnReasonSelection: {
    pageType: 'order management screen',
    pageName: 'return reason selection screen'
  },
  exchangeSizeReasonSelection: {
    pageType: 'order management screen',
    pageName: 'exchange size reason selection screen'
  },
  returnExchangePaymentModeSelection: {
    pageType: 'order management screen',
    pageName: 'return payment mode selection screen'
  },
  returnExchangeSuccess: {
    pageType: 'thank you screen'
  },
  storeLandingScreen_Trends_LUX: {
    pageType: 'landing screen'
  },
  myAccountAjioWalletOverview: {
    pageType: 'wallet screen',
    pageName: 'wallet overview screen'
  },
  myAccountAjioWalletPoints: {
    pageType: 'wallet screen',
    pageName: 'wallet points screen'
  },
  myAccountAjioWalletCash: {
    pageType: 'wallet screen',
    pageName: 'wallet cash screen'
  },
  myAccountAjioWalletHistoryScreen: {
    pageType: 'wallet screen',
    pageName: 'wallet transactions history screen'
  },
  myAccountMyRewards: {
    pageType: 'reward screen',
    pageName: 'rewards screen'
  },
  orderCancellationConfirm: {
    pageType: 'order  management screen',
    pageName: 'order cancellation screen '
  },
  selfCare: {
    pageType: 'customer care - self care screen',
    pageName: 'customer care - self care screen'
  },
  selfCareItemDetail: {
    pageType: 'customer care - item details screen',
    pageName: 'customer care - item details screen'
  },
  selfCareFaq: {
    pageType: 'customer care - item details screen',
    pageName: 'customer care - item details screen'
  },
  selfCareCallBack: {
    pageType: 'customer care - item details - faq screen',
    pageName: 'customer care - item details - faq screen'
  },
  faqHalfCard: {
    pageType: 'customer select items - self care screen',
    pageName: 'customer select items - self care screen'
  },
  faqChatScreen: {
    pageType: 'customer care - item details - faq screen',
    PageName: 'customer care - item details - faq screen'
  },
  callMeBackScreen: {
    pageType: 'Call me back screen',
    pageName: 'Call me back screen'
  },
  selfCareFaqItemDetail: {
    pageType: 'customer care - item details - faq screen',
    pageName: 'customer care - item details - faq screen'
  },
  havingTroubleClose: {
    pageType: 'user account screen',
    pageName: 'Having Trouble screen'
  },
  sizeGuide: {
    pageType: 'size guide',
    pageName: 'size guide'
  }
};

export default screens;
